<template>
  <div class="w3-main main-container">

    <page-header />

    <div class="w3-container about-container">
      <h1 class="w3-xxxlarge"><b>Adatvédelmi nyilatkozat</b></h1>
      <hr class="w3-round">

      <p>
        Az Alexy Üvegtechnika Orosháza Kft., a becreative.glass tulajdonosa kiemelt figyelmet fordít a látogatók és a regisztrált felhasználók adatainak biztonságos
        kezelésére. Cégünk vállalja, hogy minden esetben a hatályos hazai törvények szerint jár el az adatkezelésben (jelenleg
        az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvény). Az adatokat bizalmasan
        kezeljük, harmadik félnek nem továbbítjuk azokat. A weboldal használatával, valamint adatai önkéntes (mind személyes,
        mind elektronikus úton történő) megadásával Ön hozzájárul, hogy az adatokat felhasználjuk az oldal üzemeltetéséhez,
        fejlesztéséhez, promóciós- és egyéb marketingtevékenységekhez. Regisztrált partnereink a következő csatornákon kaphatnak
        promóciós anyagot: levélposta, telefon, e-mail, webes felület (becreative.glass és aldomanjei). A felhasználó bármikor kérvényezheti
        a promóciós anyagok kézbesítésének megszüntetését, illetve adatainak módosítását, vagy indoklás nélküli törlését
        az erre megfelelő webes felületeken, vagy írásban (5900 Orosháza, Juhász Gyula u. 5091/1 hrsz.). Az adatkezelés jogalapja a
        felhasználó hozzájárulása. Amennyiben a felhasználó nem mutat aktivitást az elektronikus felületeken, az Alexy Üvegtechnika Orosháza Kft.
        2 évig őrzi meg az adatokat, ennek letelte után a felhasználó minden adata törlésre kerül. Az Alexy Üvegtechnika Orosháza Kft. fenntartja
        a jogot jelen adatvédelmi nyilatkozat megváltoztatására, a felhasználók értesítése mellett.
      </p>

      <p><b>Adatkezelő elérhetőségei:</b></p>

      <p>
        Alexy Üvegtechnika Orosháza Kft.<br>
        Cím: H-5900 Orosháza, Juhász Gyula u. 5091/1 hrsz.<br>
        Telefon: +36 20 330 0518<br>
        E-mail: info@becreative.glass
      </p>

      <p><b>COOKIE-K (SÜTIK):</b></p>

      <p>
        A sütik információkat gyűjtenek az becreative.glass és aloldalainak (továbbiakban: becreative.glass) látogatóiról és eszközeikről; megjegyzik a látogatók egyéni beállításait, amelyek felhasználásra kerül(het)nek.
        Ezen sütik lejáratukig a látogató számítógépén vagy böngészésre használt más eszközén, annak böngészőjében maradnak, illetve amíg a látogató nem törli őket.
        Feltétlenül szükséges cookie-k: Ezen sütik célja, hogy a látogatók maradéktalanul és zökkenőmentesen böngészhessék az becreative.glass-t, használhassák annak funkcióit, és az ott elérhető szolgáltatásokat.
        Harmadik féltől származó cookie-k:
      </p>

      <ul>
        <li>Google Analytics: statisztikai célú szolgáltatás használatával információkat gyűjt azzal kapcsolatban, hogy a látogatók hogyan használják az becreative.glass-t.
          Az adatot a honlap fejlesztésének és a felhasználói élmény javításának céljával használja fel.
          Honlapunk aktiváltatta az IP-címek anonimizálását, így az Analytics az Adatgyűjtő Hálózat lehető legkorábbi szakaszában anonimmá teszi a címet.
          Ezen sütik működésére a Google adatvédelmi irányelvei vonatkoznak ( <a href="https://support.google.com/analytics/answer/6004245?hl=hu" target="_blank">https://support.google.com/analytics/answer/6004245?hl=hu</a> ).</li>
      </ul>

      <p><b>Jogorvoslati lehetőséggel a következő hatóságnál lehet élni:</b></p>

      <p>
        Nemzeti Adatvédelmi és Információszabadság Hatóság<br>
        Cím: H-1125 Budapest, Szilágyi Erzsébet fasor 22/c<br>
        Posta cím: H-1530 Budapest, Pf.: 5<br>
        Telefon: +36 1 391 1400<br>
        Fax: +36 1 391 1410<br>
        E-mail: ugyfelszolgalat@naih.hu
      </p>

      <p>
        A weboldal, vagy egyéb elektronikus szolgáltatás igénybevételével a felhasználó elfogadja jelen adatvédelmi nyilatkozatot.
      </p>
    </div>
  </div>
</template>

<script>
  import PageHeader from '@/components/PageHeader';

  export default {
    name: 'privacy-statement',
    mounted() {
      scrollTo(0, 0);
    },
    computed: {
      host() {
        return location.host;
      },
    },
    components: {
      PageHeader,
    },
  };

</script>

<style scoped>
  a {
    word-break: break-word;
  }

  .about-container {
    margin-top: 75px;
    max-width: 1000px;
  }

  hr {
    width: 50px;
    border: 5px solid;
    color: #eb2e4a !important;
    margin-top: 0px;
  }

</style>



// WEBPACK FOOTER //
// PrivacyStatement.vue?541ef01f